<template>
	<div full-height grey-back>
		<v-toolbar flat fixed>
		    <v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
		    <v-toolbar-title class="white--text">
		    	{{$route.query.usertype ? 'New Business' : $root.CurrentBusiness.IsAccountantOnly ? 'User Details' : 'Business Profile'}}
		    </v-toolbar-title>
		    <!-- <v-spacer></v-spacer> -->
		    <!-- <v-btn round-borders outline @click="fn_checkValidations">Save</v-btn> -->
		</v-toolbar>

		<v-form class="form-element hasBigFooter hasToolbar" v-if="!$root.CurrentBusiness.IsAccountantOnly || $route.query.usertype">

			<v-layout align-center padding-top-ten row wrap white-background>

				<v-flex xs12 sm12 md12 form-item padding-top-ten>
	               <v-text-field  
	               		v-model="Form.BusinessName" 
	               		label="Business Name" 
	               		placeholder=" "
	               		v-validate="'required'"
	               		data-vv-name="businessName" 
	               		data-vv-as="business name" 
	               		:error-messages="errors.collect('businessName')"
	               		required>
	               			
	               	</v-text-field>
	            </v-flex>

	            <v-flex xs12 sm12 md12 form-item padding-top-ten>
                   <v-text-field  
                        v-model="Form.UserName" 
                        label="Business Owner Name"
                        placeholder=" "
                        v-validate="'required'"
                        data-vv-name="username" 
                        data-vv-as="business owner name" 
                        :error-messages="errors.collect('username')"
                        required>
                    </v-text-field>
                </v-flex>

	            <v-flex xs12 sm12 md12 form-item padding-top-ten>
               		<v-textarea
               			v-model="Form.Address"
			          	label="Address (will appear on invoice and bill prints)"
			          	placeholder=" "
			          	rows="2"
			          	counter="250"
			          	v-validate="'max:250'"
	               		data-vv-name="address" 
	               		data-vv-as="address" 
	               		:error-messages="errors.collect('address')"
	               		required>
			        </v-textarea>
	            </v-flex>

                <!-- <v-flex xs12 sm12 md12 form-item>
               		<v-text-field 
               			v-model="Form.Email"
			          	label="Email"
			          	placeholder=" "
			          	v-validate="'email'"
	               		data-vv-name="email" 
	               		data-vv-as="email" 
	               		:error-messages="errors.collect('email')"
	               		required>
			        </v-text-field>
	            </v-flex> -->

	            <v-flex xs12 sm12 md12 form-item padding-top-ten @click="fn_openStateDialog('android', 'state', 'ref_fieldState')">
               		<v-text-field  
               			readonly
               			:onUpdate="fn_updateState"
               			ref="ref_fieldState"
               			v-model="Form.State" 
               			label="State" 
               			placeholder=" " 
               			append-icon="arrow_drop_down"
               			v-validate="'required'"
	               		data-vv-name="state" 
	               		data-vv-as="state" 
	               		:error-messages="errors.collect('state')"
	               		required>
               		</v-text-field>
	            </v-flex>

				<v-flex xs12 sm12 md12 form-item padding-top-ten>
                   <v-text-field 
						type="number"
                        v-model="Form.Pincode" 
                        label="Pincode"
                        placeholder=" ">
                    </v-text-field>
                </v-flex>

	            <v-flex xs12 sm12 md12 form-item>
               		<v-text-field  
               			:disabled="true"
               			readonly
               			v-model="Form.BusinessProfileNumber" 
               			label="Business Profile Number" 
               			placeholder=" ">
               		</v-text-field>
	            </v-flex>
			</v-layout>

			<v-layout row wrap padding-top-ten white-background>

				<v-flex xs12 sm12 md12 form-item @click="fn_openRegistrationTypes">
	               <v-text-field  
		               	readonly
		               	:value="registrationType"
		               	label="GST Registration Status"
		               	placeholder=" " 
		               	append-icon="arrow_drop_down"
		               	v-validate="'required'" 
	               		data-vv-name="status" 
	               		data-vv-as="GST registration status" 
	               		:error-messages="errors.collect('status')"
	               		required>
	               </v-text-field>
	            </v-flex>

            	<!-- <v-flex xs12 sm12 md12 form-item v-if="Form.GSTRegistrationStatus == 1 || Form.GSTRegistrationStatus == 2">
	               <v-text-field
	               		uppercase  
	               		label="GST Number (GSTIN)" 
	               		:hide-details="!errors.has('gstNumber')"
	               		placeholder=" " 
	               		v-model="Form.GSTNumber" 
	               		v-validate="'required|nospace|min:15|max:15'"
	               		name="GSTNumber" 
	               		data-vv-name="gstNumber" 
	               		data-vv-as="gst number" 
	               		:error-messages="errors.collect('gstNumber')" 
	               		required>
	               	</v-text-field>
	               	<div class="pt-1" right-align font12 light-opacity-color>Example: 12ABCDE1234A9Z9</div>
	            </v-flex> -->

	            <v-flex xs12 sm12 md12 form-item padding-top-ten v-if="Form.GSTRegistrationStatus == 1 || Form.GSTRegistrationStatus == 2">
	               <v-text-field
	               		uppercase  
	               		label="GST Number (GSTIN)" 
	               		:hide-details="!errors.has('gstNumber')"
	               		placeholder=" " 
	               		v-model="Form.GSTNumber" 
	               		v-validate="'required|verify_gstnumber'"
	               		name="GSTNumber" 
	               		data-vv-name="gstNumber" 
	               		data-vv-as="GST number" 
	               		:error-messages="errors.collect('gstNumber')" 
						@input="fn_gstInput"
	               		required>
	               	</v-text-field>
	               	<div class="pt-1" right-align font12 light-opacity-color>Example: 12ABCDE1234A9Z9</div>
	            </v-flex>

	  	  		<!-- <v-checkbox v-if="Form.GSTRegistrationStatus==1"
	  	  			right-align-checkbox form-item 
	  	  			label="HSN Applicable" 
	  	  			v-model="Form.HSNApplicable">
	  	  		</v-checkbox> -->
			</v-layout>

			<v-layout row wrap white-background padding-top-ten>
			  	<v-subheader full-width v-if="Form.GSTRegistrationStatus==1">Tax</v-subheader>
	            <v-flex xs12 sm12 md12 form-item v-if="Form.GSTRegistrationStatus==1">
	                <v-radio-group v-model="Form.TaxMode" row>
	                  	<v-radio label="Exclusive" :value="1"></v-radio>
	                  	<v-radio label="Inclusive" :value="2"></v-radio>
						<v-radio label="None" :value="0"></v-radio>
	                </v-radio-group>
	            </v-flex>
			</v-layout>

		</v-form>

		<v-form class="form-element hasBigFooter hasToolbar grey-back" v-else>
            <v-layout align-center nomargin padding-top-ten row wrap white-background>

                <!-- don't remove -->
                <v-flex xs12 sm12 md12 form-item padding-top-ten>
                   <v-text-field  
                        v-model="Form.UserName" 
                        label="Your Name" 
                        placeholder=" "
                        v-validate="'required'"
                        data-vv-name="username" 
                        data-vv-as="name" 
                        :error-messages="errors.collect('username')"
                        required>
                    </v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md12 form-item padding-top-ten @click="fn_openStateDialog('android', 'state', 'ref_fieldState')">
                    <v-text-field  
                        readonly
                        :onUpdate="fn_updateState"
                        ref="ref_fieldState"
                        v-model="Form.State" 
                        label="State" 
                        placeholder=" " 
                        append-icon="mdi-menu-down"
                        v-validate="'required'"
                        data-vv-name="state" 
                        data-vv-as="state" 
                        :error-messages="errors.collect('state')"
                        required>
                    </v-text-field>
                </v-flex>
            </v-layout>
        </v-form>

		<div white-background full-width nopadding style="position:fixed;bottom:0;">
			<v-layout row wrap>
				<v-flex xs12 sm12 md12 height48>
					<v-btn color="primary" full-height nomargin block no-round-borders :disabled="disableBtn" noshadow @click="fn_checkValidations">Save</v-btn>
				</v-flex>
			</v-layout>
		</div>

	<!-- 	<div class="page-footer custom" grey-back>
            <div class="watermark">
                <div class="title">BizOps</div>
            </div>
        </div> -->

		<!-- <dialog-date-picker ref="ref_dialogDatePicker" :selected="Form.GSTRegistrationDate" :updateDate="fn_updateDate"></dialog-date-picker> -->

		<!-- <dialog-confirmation ref="ref_dialogConfirmation" :header="header" :actionMethod="actionMethod"></dialog-confirmation> -->
	    <dialog-discard ref="ref_dialogDiscard" :draftAction="fn_confirmExit" :save="fn_checkValidations" :hideKeepDraft="true"></dialog-discard>

		<dialog-registration-types ref="ref_dialogRegistrationTypes" :registrationTypes="registrationTypes" :selectedRegistrationType="Form.GSTRegistrationStatus"></dialog-registration-types>
		<dialog-selection-list ref="ref_dialogSelectionList" :closeDialog="fn_closeDialog" :fnOnChange="fn_onChange"></dialog-selection-list>

		<v-snackbar :timeout="0" v-model="msgAlert">Something went wrong. Try again!
			<v-btn flat color="primary" @click.native="fn_checkValidations">retry</v-btn>
		</v-snackbar>
	</div>
</template>

<script>
const dialogjs =  require('../masters/forms/dialog').dialogjs;
// import dialogDatepicker from './dialogs/dialog_datepicker'
import dialogRegistrationTypes from './dialogs/dialog_registration_types'
// import dialogConfirmation from '../dialogs/dialog_confirmation'
import dialogDiscard from '../dialogs/dialog_discard'
import dialogSelectionList from '../dialogs/dialog_selection_list'

	export default{
		data(){
			return{
				Form:{"BusinessID":null, "BusinessName":null, "UserName":null, "Address":null, "StateID":null, "State":null, "Pincode":null, "BusinessProfileNumber":null, "GSTRegistrationStatus":null, "GSTNumber":null, "GSTRegistrationDate":null, "HSNApplicable":false, "TaxMode":null, "businessLogo":null, "UserType":null, "IsAccountantOnly":null, "Email":null},
				formId:null,
				dialogStorageId:null,
				confirmExit:false,
				header:null,
				actionMethod:null,
				registrationTypes:[{"status":1, "name":"Registered - Regular"},{"status":2, "name":"Registered - Composite"},{"status":3, "name":"Unregistered"}],
				msgAlert:false,
				FormCopy:null,
				disableBtn:false,
				businessData:null
			}
		},
		components:{
			// 'dialog-date-picker': dialogDatepicker,
			// 'dialog-confirmation': dialogConfirmation,
			'dialog-discard': dialogDiscard,
			'dialog-registration-types':dialogRegistrationTypes,
			'dialog-selection-list':dialogSelectionList
		},
		methods: {

			fn_openRegistrationTypes: function(){
				this.fn_openDialogWeb('web', 'OTP', 'ref_dialogRegistrationTypes');
			},

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var dialogObj = {};
				dialogObj.tagId = this.guidWeb();
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			// fn_openStateDialog: function(platform, name, ref){

			// 	let viewDialogObject = { ToolbarTitle:"State", fnName:"StateDialog" };

			// 	if(this.Form.StateID && this.Form.State){
			// 		viewDialogObject.defaultValue = {"itemId":this.Form.StateID, "itemName":this.Form.State};
			// 	}

			// 	viewDialogObject.ref = ref;
			// 	localStorage.setItem('dialog_properties', JSON.stringify(viewDialogObject));

			// 	this.fn_openDialogWeb('web', 'State', 'ref_dialogSelectionList');
			// },

			fn_openStateDialog: function (platform, name, ref) {

				var tagId = this.guidWeb();

				var dialogObj = {};
				dialogObj.tagId = tagId;
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.platform = platform;

				var self = this;

				var viewDialogObject = {};
				viewDialogObject.ToolbarTitle = "Select State";
				viewDialogObject.isBottomMenu = false;

				var paramObject = {};
				paramObject.defaultValue = {"id":null, "name":null};

				if(this.Form.StateID && this.Form.State){
					paramObject.defaultValue = {"id":this.Form.StateID, "name":this.Form.State};
				}

				var self = this;
				dialogjs.fn_openDialog(this, dialogObj, viewDialogObject, 'state', tagId, paramObject, ref);
			},

			fn_onChange: function(tagId, ref, selectedValueId, selectedValueName, isRemoved){
				this.$refs[ref].$attrs.onUpdate(selectedValueId, selectedValueName, isRemoved);
			},

			fn_updateState: function (selectedValueId, selectedValueName, isRemoved) {
				if(!isRemoved){
					this.Form.StateID = selectedValueId;
		        	this.Form.State = selectedValueName;
		        	this.errors.remove('state');
				}
				else{
					this.Form.StateID = null;
		        	this.Form.State = null;
				}
				this.$forceUpdate();
			},

			fn_closeDialog: function () {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_updateDate: function (value) {
				this.Form.GSTRegistrationDate = this.$moment(value).format('DD-MMM-YYYY');
				this.errors.remove('wef');
				this.fn_closeDialog();
			},

			// fn_openDatepicker: function () {
			// 	this.fn_openDialogWeb('web', 'OTP', 'ref_dialogDatePicker');
			// },

			fn_showWebView: function () {
				var viewObject = {};
				viewObject.isBottomMenu = true;

				var tagId = this.formId;
				var self = this;
				this.showWebView(tagId, viewObject, 
					{
						onSuccess: function(response){
				          console.log(response);
				        }, 
				        onError: function(error){
				          console.log(error);
				        }, 
				        // onChange: null,
				        onMenuItemClick: function (tagId, menuId, menuAction) {
							self.fn_menuItemClick(tagId, menuId, menuAction)
						}
					}
				);
			},

			fn_gstInput: function(){
				this.$nextTick(() => {
					this.Form.GSTNumber = this.Form.GSTNumber.replace(/\s+/g, "");	
				});
			},

			fn_checkValidations: function(){
				this.disableBtn = true;
				// this.$nextTick(() => {
				// 	this.Form.GSTNumber = this.Form.GSTNumber.replace(/\s+/g, "");	
				// });
				this.$validator.validateAll().then((result) => {
			        if (result) {

			        	if(this.Form.GSTRegistrationStatus==3){
			        		this.Form.GSTNumber = null;
			        		this.Form.GSTRegistrationDate = null;
			        		this.Form.HSNApplicable = false;
			        	}
						else if(this.Form.GSTRegistrationStatus==2){
			        		this.Form.HSNApplicable = false;
			        	}
						else{
							this.Form.HSNApplicable = true;
						}

			        	// if(!this.$route.query.usertype){
			        	// 	this.fn_updateBusinessDetail();
			        	// }
			        	// else{
			        	// 	this.fn_getToken();
			        	// }
						this.fn_getToken();
			        }
			        else{
			        	this.disableBtn = false;
			        	this.$vuetify.goTo('.error--text', this.scrollOptions);
			        }
			    });
			},

			// fn_getToken: function(){
			// 	let self = this;
			// 	this.$root.fn_getAuthToken(function(token){
			// 		self.fn_updateBusiness(token);
			// 	})
			// },

			// fn_updateBusiness: function(token){
			// 	this.fn_closeDialog();
				
			// 	if(!navigator.onLine){
			// 		this.showToast("Internet not available");
			// 		return;
			// 	}
				
			// 	var self = this;
			// 	this.msgAlert = false;
			// 	this.showLoading('Updating business profile...');
			// 	this.Form.autoBackupTime = this.$root.fn_autoBackupTime(this.$root.defaultBackupTime);
			// 	this.Form.GSTNumber ? this.Form.GSTNumber = this.Form.GSTNumber.toUpperCase() : '';
			// 	this.Form.token = token;

			// 	this.postServerData('UpdateBusiness', this.Form, 
			// 		{
			// 			onSuccess: function(response){
			// 	          	console.log(response);
			// 	          	let business = JSON.parse(response);
			// 	          	self.fn_updateBusinessDetail(business);
			// 	          	// let business = JSON.parse(response);
			// 	          	// self.fn_reopenDatabase(business);
			// 	        }, 
			// 	        onError: function(error){
			// 	          console.log(error);
			// 	          self.hideLoading();
			// 	          self.msgAlert = true;
			// 	          if(typeof JSON.parse(error) == 'object'){
			// 	          	let response = JSON.parse(error);
			// 	          	self.showToast(response.Message);
			// 	          }
			// 	        }, 
			// 		}
			// 	);
			// },

			fn_getBusinessMasterData: function(){
				let self = this;
		        this.getData('BusinessDetail', this.$root.CurrentBusiness.BusinessID, 
		            {
		              onSuccess: function(response){
		                  console.log(response);
		                  self.businessData = JSON.parse(response);
		              }, 
		              onError: function(error){
		                  console.log(error);
		              }
		            }
		        );
			},

			// fn_updateBusinessDetail: function(){
			// 	this.fn_closeDialog();

			// 	let self = this;

			// 	let postObj = JSON.parse(JSON.stringify(this.businessData));
			// 	postObj.BusinessID =  this.Form.BusinessID;
			// 	postObj.BusinessName =  this.Form.BusinessName.trim();
			// 	postObj.UserName =  this.Form.UserName;
			// 	postObj.Address =  this.Form.Address;
			// 	postObj.StateID =  this.Form.StateID;
			// 	postObj.State =  this.Form.State;
			// 	postObj.BusinessProfileNumber =  this.Form.BusinessProfileNumber;
			// 	postObj.GSTRegistrationStatus =  this.Form.GSTRegistrationStatus;
			// 	postObj.GSTNumber =  this.Form.GSTNumber;
			// 	postObj.TaxMode =  this.Form.TaxMode;
			// 	postObj.HSNApplicable =  this.Form.HSNApplicable;
			// 	postObj.UserType =  this.Form.UserType;
			// 	postObj.IsAccountantOnly =  this.Form.IsAccountantOnly;
            //     postObj.Email =  this.Form.Email;
			// 	postObj.GSTRegistrationDate = postObj.GSTRegistrationDate ? new Date(postObj.GSTRegistrationDate) : null;
			// 	postObj.GSTNumber ? postObj.GSTNumber = postObj.GSTNumber.toUpperCase() : '';
			// 	postObj.ModifiedOn = this.$root.fn_getLocalDateFormat();
			// 	let businessStatusOld = this.$root.CurrentBusiness.GSTRegistrationStatus;
			// 	console.log(JSON.stringify(postObj));
			// 	this.postData('UpdateBusinessDetail', postObj, 
			// 		{
			// 			onSuccess: function(response){
			// 	          	console.log(response);
			// 	          	self.hideLoading();
			// 	          	let toastMsg = self.$root.CurrentBusiness.IsAccountantOnly ? 'Details updated' : 'Business profile updated';
			// 	          	self.showToast(toastMsg);
			// 	          	self.confirmExit = true;
			// 	          	self.$root.fn_getBusiness('goback', businessStatusOld);
			// 	        }, 
			// 	        onError: function(error){
			// 	        	self.hideLoading();
			// 	        	self.showToast('Something went wrong. Try again');
			// 	        	self.msgAlert = true;
			// 	          	console.log(error);
			// 	        }, 
			// 		}
			// 	);
			// },

			fn_getToken: function(){
				let self = this;
				this.showLoading('Updating business profile...');
				this.$root.fn_getAuthToken(function(token){
					if(token == 'error'){
						self.disableBtn = false;
						self.hideLoading();
						self.showToast("Something went wrong");
						return;
					}

					self.fn_updateBusinessDirect(token);
				})
			},

			fn_updateBusinessDirect: function(token){
				this.fn_closeDialog();

				let self = this;

				let postObj = JSON.parse(JSON.stringify(this.businessData));

				
				postObj.BusinessID =  this.Form.BusinessID;
				postObj.BusinessName =  this.Form.BusinessName.trim();
				postObj.UserName =  this.Form.UserName;
				postObj.Address =  this.Form.Address;
				postObj.StateID =  this.Form.StateID;
				postObj.State =  this.Form.State;
				postObj.Pincode =  this.Form.Pincode;
				postObj.BusinessProfileNumber =  this.Form.BusinessProfileNumber;
				postObj.GSTRegistrationStatus =  this.Form.GSTRegistrationStatus;
				postObj.GSTNumber =  this.Form.GSTNumber;
				postObj.TaxMode =  this.Form.TaxMode;
				postObj.HSNApplicable =  this.Form.HSNApplicable;
                // postObj.Email =  this.Form.Email;
				postObj.UserType =  this.Form.UserType;
				// postObj.IsAccountantOnly = false;
				if(this.$route.query.usertype){
					postObj.IsAccountantOnly = false;
				}
				else{
					postObj.IsAccountantOnly = this.Form.IsAccountantOnly;
				}
				postObj.Email =  this.Form.Email;

				postObj.GSTRegistrationDate = postObj.GSTRegistrationDate ? new Date(postObj.GSTRegistrationDate) : null;
				postObj.GSTNumber ? postObj.GSTNumber = postObj.GSTNumber.toUpperCase() : '';
				postObj.ModifiedOn = this.$root.fn_getLocalDateFormat();

				postObj.token = token;

				let businessStatusOld = this.$root.CurrentBusiness.GSTRegistrationStatus;

				// console.log(JSON.stringify(postObj));

				this.postServerData('UpdateBusinessDirect', postObj, {
                    onSuccess: function(response){
                       console.log(response);
			          	self.confirmExit = true;
						if(!self.$route.query.usertype){
							self.hideLoading();
							let toastMsg = self.$root.CurrentBusiness.IsAccountantOnly ? 'Details updated' : 'Business profile updated';
				          	self.showToast(toastMsg);
				          	self.$root.fn_getBusiness('goback', businessStatusOld);
						}
						else{
							self.$root.fn_getBusiness(null, null, function(){
								self.$root.fn_pushDefaultJson(function(){
									self.hideLoading();
									self.showToast('Business profile updated');
									self.$router.replace('/actions');
								})
							});
						}
			          	
                    }, 
                    onError: function(error){
                       console.log(error);
                       self.hideLoading();
                       if(typeof JSON.parse(error) == 'object'){
                         let response = JSON.parse(error);
                         self.showToast(response.Message);
                       }
                    }, 
                })

				// this.postServerData('UpdateBusinessDirect', postObj, 
				// 	{
				// 		onSuccess: function(response){
				//           	console.log(response);
				//           	self.confirmExit = true;
				//           	self.$root.fn_getBusiness(null, null, function(){
				//           		self.$root.fn_pushDefaultJson(function(){
				//           			self.hideLoading();
				//           			self.showToast('Business profile updated');
				//           			self.$router.replace('/actions');
				//           		})
				//           	});
				//         }, 
				//         onError: function(error){
				//         	self.hideLoading();
				//         	self.showToast('Something went wrong. Try again');
				//         	self.msgAlert = true;
				//           	console.log(error);
				//         }, 
				// 	}
				// );
			},

			fn_bindData: function(){
				this.Form.BusinessID = this.$root.CurrentBusiness.BusinessID;
				this.Form.BusinessName = this.$route.query.usertype ? null : this.$root.CurrentBusiness.BusinessName;
				this.Form.UserName = this.$root.CurrentBusiness.UserName;
				this.Form.Address = this.$root.CurrentBusiness.Address;
				this.Form.StateID = this.$root.CurrentBusiness.StateID;
				this.Form.State = this.$root.CurrentBusiness.State;
				this.Form.Pincode = this.$root.CurrentBusiness.Pincode;
				this.Form.BusinessProfileNumber = this.$root.CurrentBusiness.BusinessProfileNumber;
				this.Form.GSTRegistrationStatus = this.$root.CurrentBusiness.GSTRegistrationStatus;
				this.Form.GSTNumber = this.$root.CurrentBusiness.GSTNumber;
				this.Form.TaxMode = this.$root.CurrentBusiness.TaxMode;
				this.$root.CurrentBusiness.GSTRegistrationDate ? this.fn_updateDate(this.$root.CurrentBusiness.GSTRegistrationDate) : '';
				this.Form.HSNApplicable = this.$root.CurrentBusiness.HSNApplicable;

				this.Form.UserType = this.$route.query.usertype ? this.$route.query.usertype : this.$root.CurrentBusiness.UserType;
				this.Form.IsAccountantOnly = this.$root.CurrentBusiness.IsAccountantOnly;
                this.Form.Email = this.$root.CurrentBusiness.Email;
				this.FormCopy = JSON.parse(JSON.stringify(this.Form));
			},

			// fn_openDialogConfirmation: function () {
			// 	this.fn_openDialogWeb('web', 'OTP', 'ref_dialogConfirmation');
			// },

			fn_openDialogDiscard: function () {
				this.fn_openDialogWeb('web', 'OTP', 'ref_dialogDiscard');
			},

			fn_confirmExit: function(){
				this.confirmExit = true;
				this.fn_closeDialog();
				this.fn_goBack();
			},

			fn_goBack: function(){
				this.$router.go(-1);
			}
		},
		
		mounted: function(){

			this.$validator.extend('verify_gstnumber', {
			    getMessage: field => 'GST Number is not valid.',
			    validate: value => {
			        // var strongRegex = new RegExp("^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})+$");
					var strongRegex = new RegExp("^([0][1-9]|[1-2][0-9]|[3][0-7])([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[a-zA-Z]{1}[0-9a-zA-Z]{1})+$");
			        return strongRegex.test(value);
			    }
			});

			// this.$validator.extend('nospace', {
			//     getMessage: field => 'Space characters are not allowed.',
			//     validate: value => {
			//         var regpan = /^\S+$/;
			//         return regpan.test(value);
			//     }
			// });
			
			if(this.$route.params && this.$route.params.businessid){//in case of edit form
				this.formId = this.$route.params.businessid;
				this.dialogStorageId = 'dialog_'+this.businessid;
				this.fn_bindData();
				this.fn_getBusinessMasterData();
			}
			else{
				this.FormCopy = JSON.parse(JSON.stringify(this.Form));
			}

			window.js_globals.fn_onBackPress = this.fn_goBack;
			window.js_globals.fn_closeClick = this.fn_closeDialog;

			this.fn_showWebView();
		},

		computed:{
			registrationType: function(){
				const keyMap = {
					1: 'registration.businessDetails.registeredRegular',
					2: 'registration.businessDetails.registeredComposite',
					3: 'registration.businessDetails.unregistered'
				};
				return keyMap[this.Form.GSTRegistrationStatus] ? this.$t(keyMap[this.Form.GSTRegistrationStatus]) : null;
			}
		},

	     beforeRouteLeave (to, from, next) {
	    	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
			if(dialogData && dialogData.length){
				dialogjs.fn_checkAndCloseOpenDialogs(this);
				next(false);
			}
			// else if(!this.confirmExit){
			// 	this.actionMethod = this.fn_confirmExit;
			// 	this.header = "Quit Updates?"
			// 	this.fn_openDialogConfirmation();
			// 	next(false);
			// }
			else if(this.confirmExit){
				next();
			}
			else if(!this.$root.fn_deepEqual(this.Form, this.FormCopy)){
				// this.actionMethod = this.fn_confirmExit;
				// this.header = "Quit Updates?"
				// this.fn_openDialogConfirmation();
				this.fn_openDialogDiscard();
				next(false);
			}
			else{
				next();
			}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/registration/update_business.vue